import React from 'react';
import { useNavigate } from 'react-router-dom';
import foodbrand from '../../assets/foodbrand@2x.png';
import Pantalla8Lic from '../Pantalla8Lic/Pantalla8Lic';
import Header from '../../Header/Header';

function PantallaBase8Lic() {

    const navigate = useNavigate();

    const getConfirmar = async () => {

        navigate("/FaceLogin", {
            state: {
                rutaContinue: "/PantallaBase49Lic",
                typeCredential: "lic"
            }
        });

    }
    const getReintentar = async () => {
        navigate('/TipoLicencia');
    }

    return (
        <>
            <div className='initBack_P2 animate__animated animate__fadeIn'>

                <Header imgBack={true} rutaBack='/TipoLicencia' title='Licencia de Conducir' />

                <Pantalla8Lic />

                <div className="footer">
                    <div className='containerCont_P2'>
                        <button className='button_P2' onClick={getConfirmar} >
                            <span className='txtButton_P2'>Confirmar</span>
                        </button>
                        <div className="spaceButton14" />
                        <button className='buttonRein_P2' onClick={getReintentar} >
                            <span className='txtButtonRein_P14'>Reintentar</span>
                        </button>
                    </div>
                    <div className='imageContainer_P2'>
                        <img src={foodbrand} className='imgFooter_P2' />
                    </div>
                </div>
            </div>
        </>
    )
}

export default PantallaBase8Lic
